"use client";

import { X } from "@phosphor-icons/react/dist/ssr";
import { usePathname, useRouter } from "next/navigation";

export default function RemoveFromComparison({
  uuidToRemove,
  slug,
}: {
  uuidToRemove: string;
  slug: string;
}) {
  const path = usePathname();
  const router = useRouter();
  const removeProject = () => {
    const newSlug = slug
      .split(",")
      .filter((x) => x != uuidToRemove)
      .join(",");
    router.push(`/compare/${newSlug}`);
  };
  return (
    <>
      <X
        size={14}
        className="inline-block cursor-pointer"
        onClick={removeProject}
      />
    </>
  );
}
